import angular from 'angular';

import sectionSvgUploadModule from '../section.svg.upload/section.svg.upload.module';
import svgUnitModule from '../svg.unit/svg.unit.module';
import notificationModule from '../ui/notification/notification.module';
import { svgSection } from './svg.section.directive';
import { SvgSection } from './svg.section.resource';

export default angular
  .module('svg.section', [
    sectionSvgUploadModule.name,
    notificationModule.name,
    svgUnitModule.name,
  ])
  .directive('svgSection', svgSection)
  .factory('SvgSection', SvgSection);
